import { viewModel } from "./ViewModel";

export function getViewModelNewValues(): viewModel {
  let r: viewModel = {
    transportDate: null,
    contact: "",
    location: "",
    returnSitePhoneNumber: "",
    returnSiteEMail: "",
    requestLoadService: false,
    notes: "",
  };
  return r;
}